<template>
  <div class="table-container-inner">
    <div class="actions">
      <button
          class="table-actions-button btn-green"
          type="button"
          @click="cancel()"
      >
        Назад
      </button>
      <button
          class="table-actions-button btn-yellow"
          type="button"
          @click="downloadExcel()"
      >
        Отчет по ошибкам
      </button>
    </div>
    <span>
      Количество ошибок: {{tmzErrorCount ? tmzErrorCount.count_tmz_error : 0 }} позиции.
    </span>
    <table>
      <thead>
      <tr class="tr-fixed-height">
      <tr>
        <th>№ п/п</th>
        <th>АБП</th>

      </tr>
      </thead>
      <tbody v-for="(request, index) in this.tmzError" :key="request.id">
      <td>{{ index + 1 }}</td>
      <td>{{ request.message }}</td>
      </tbody>
    </table>

    <div class="search">
      <input class="search__input" type="text" v-model="searchText">
      <button class="search__btn transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white" @click="search">Поиск</button>
      <button class="search__btn transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white" @click="clear">Сбросить</button>
    </div>

    <!--  Tables  -->
    <VLTable v-if="step <= 1 && vlData" :report.sync="vlData" />
    <NVLTable v-if="nvlData && step === 2 || step === 3" :report.sync="nvlData" :tmzReport="TMZREPORT" />
    <NLTable v-if="step >= 4 && nlData" :report.sync="nlData" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from "axios";
import VLTable from "@/components/tables/VLTable";
import NVLTable from "@/components/tables/NVLTable";
import NLTable from "@/components/tables/NLTable";
import NProgress from "nprogress";
import store from "@/store";
export default {
  name: "ErrorTmz",
  components: {
    VLTable,
    NVLTable,
    NLTable
  },
  data() {
    return {
      tmzError: [],
      tmzErrorCount: {},
      searchText: '',
      vlData: '',
      nvlData: '',
      nlData: '',
      step: ''
    }
  },
  beforeRouteEnter(to, from, next) {
    NProgress.start();
    store.dispatch('getTmzReport', to.params.id).then(() => {
      NProgress.done();
      next();
    });
  },
  mounted() {
    this.step = this.TMZREPORT.step
  },
  methods: {
    clear () {
      this.searchText = ''
    },
    search () {
      if (this.step <= 1) {
        this.getVlData()
      } else if (this.step === 2 || this.step === 3) {
        this.getNvlData()
      } else {
        this.getNlData()
      }
    },
    getVlData() {
      axios.get('tmz/pre-liquid-demand-req/', {
        params: {
          "tmz_id": this.$route.params.id,
          "nameTmc": this.searchText
        }
      }).then((response) => {
        this.vlData = response.data
      })
    },
    getNvlData () {
      axios.get('tmz/pre-liquid-unclaimed-req/', {
        params: {
          "tmz_id": this.$route.params.id,
          "nameTmc": this.searchText
        }
      }).then((response) => {
        this.nvlData = response.data
      })
    },
    getNlData () {
      axios.get('tmz/pre-illiquid-req/', {
        params: {
          "tmz_id": this.$route.params.id,
          "nameTmc": this.searchText
        }
      }).then((response) => {
        this.nlData = response.data
      })
    },
    getTmzError() {
      this.$store.dispatch("getTmzError", this.$route.params.id).then((response) => {
        this.tmzError = response;
      });
    },
    getTmzErrorCount() {
      this.$store.dispatch("getTmzErrorCount", this.$route.params.id).then((response) => {
        this.tmzErrorCount = response;
      });
    },
    cancel() {
      history.back();
    },
    downloadExcel() {
      this.$store.dispatch("downErrorExcel", this.$route.params.id);
    },
  },
  computed: {
    ...mapGetters([
      'TMZREPORT',
    ]),
  },
  created() {
    this.getTmzError();
    this.getTmzErrorCount();
  }
}
</script>


<style scoped lang="scss">
.table-container {
  /* overflow-x: auto; */
  margin: 2rem;
  min-width: 1800px;
  /* margin: 0 auto; */
  overflow: auto;
}

.table-container-inner {
  padding: 0.5rem;
  margin: 0 2rem;
  /* padding: 1rem 2rem; */
  /* margin-right: 2rem; */
  /* margin: 1rem 2rem; */
  overflow-x: auto;
  max-width: 100vw;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin: 0 auto 2rem;
  overflow-x: auto;
  border-bottom: 1px solid black;
  font-size: 14px;
}

.table-naming {
  font-size: 2rem;
  font-weight: bold;
  padding: 1rem 0;
  text-align: left;
}

.table-status {
  margin-bottom: 0.5rem;
}

th,
td {
  border: 1px solid #868686;
  padding: 0 1rem;
}

.expanded {
  padding: 0 2rem;
}

.table-specs {
  background: #36429e;
  width: 100px;
  height: 100px;
  color: white;
  text-align: center;
  border-top-left-radius: 10px;
  border: none;
  font-size: 1.5rem;
  vertical-align: bottom;
}

.table-actions {
  display: flex;
  padding: 2rem 0;
  justify-content: center;
}

.actions {
  display: flex;
  max-width: 400px;
  gap: 1rem;
}

.table-actions-button {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 1.1rem;
}

.btn-green {
  background: #7ad38d;
  color: white;
}

.btn-yellow {
  background: #ffbb56;
  color: white;
}

.btn-red {
  background: #e86363;
  color: white;
}

.btn-blue {
  background: #6c63e8;
  color: white;
}

.btn-upload-file {
  background: none;
  margin-left: -1rem;
}

.btn-green {
  background: #7ad38d;
  color: white;
}

.btn-blue {
  background: #36429e;
  color: white;
}

.file-area {
  width: 100%;
  position: relative;
}

.file-area input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
  border-radius: 25px;
}

.file-area .file-state {
  width: 100%;
  padding: 1rem 1rem;

  border-radius: 10px;
  /* margin-left: 1rem; */
  cursor: pointer;
  font-size: 1.1rem;

  background: #5769f8;
  color: #fff;
  text-align: center;
  transition: background 0.3s ease-in-out;
}

.file-area .file-state .success {
  display: none;
}

.file-area:hover .file-state {
  background: rgba(255, 255, 255, 0.1);
  color: black !important;
}

.search {
  max-width: 500px;
  margin: 0 auto;
  height: 42px;
  display: flex;
  justify-content: center;
  gap: 1rem;

  &__input {
    border: 1px solid rgba(34,36,38,.15);
    border-radius: .25rem;
    padding: 0 .8rem;
  }
}
</style>
